<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <router-link :to="accountingLink" class="nav-link">
          <i class="fa fa-cube mr-1"/>Accounting
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="chartOfAccountLink" class="nav-link">
          <i class="fa fa-list mr-1"/>Chart of Accounts
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="qboUnpublishedLink" class="nav-link">
          <i class="fa fa-cubes mr-1"/>QBO Unpublished
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="commissionLink" class="nav-link">
          <i class="fa fa-star mr-1"/>Commissions
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    metaInfo: () => ({
      title: 'New Erp',
    }),
    data() {
      return {};
    },
    computed: {
      ...mapGetters('accountingCenter', ['lastOpenedTab',
        'accountingLink',
        'chartOfAccountLink',
        'qboUnpublishedLink',
        'commissionLink'
      ]),
    },
    methods: {
      ...mapMutations('accountingCenter', ['setItem']),
    },
    watch: {},
    mounted() {
      if (!this.lastOpenedTab) {
        this.setItem({ resource: 'accountingLink', payload: this.accountingLink });
        this.setItem({ resource: 'lastOpenedTab', payload: this.accountingLink });
      }
      if (this.$route.meta.controlLink) {
        this.setItem({ resource: this.$route.meta.controlLink, payload: this.$route.fullPath });
        this.setItem({ resource: 'lastOpenedTab', payload: this.$route.fullPath });
      }
    },
  };
</script>

<style scoped>
.new-offer-button {
  right: 10px;
  position: absolute;
  top: 4px;
}
</style>
